import { LineSegments, LineBasicMaterial, Float32BufferAttribute, BufferGeometry } from 'three';
import { disposeMaterials } from './Util';

class RectangularGrid extends LineSegments {
  constructor(
    xNumberCells = 10,
    yNumberCells = 10,
    xCellSize = 1,
    yCellSize = 1,
    color = 0x808080,
    opacity = 0.5,
    linewidth = 1
  ) {
    const vertices = [];

    const xSize = xNumberCells * xCellSize;
    const ySize = yNumberCells * yCellSize;

    if (xNumberCells > 0 && yNumberCells > 0) {
      for (let index = 0, x = 0; index <= xNumberCells; x += xCellSize, index += 1) {
        vertices.push(x, 0, 0, x, ySize, 0);
      }
      for (let index = 0, y = 0; index <= yNumberCells; y += yCellSize, index += 1) {
        vertices.push(0, y, 0, xSize, y, 0);
      }
    }

    const geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    const material = new LineBasicMaterial({ color, linewidth, transparent: true, opacity });

    super(geometry, material);
  }

  dispose() {
    this.geometry.dispose();
    disposeMaterials(this.material);
  }
}

export { RectangularGrid };
